var modules_13b53a7e = {"form":"styles_module_form__0d3c3b3d"};
import "../../assets/esm/components/Form/view~CjLKWecM.css";

export { modules_13b53a7e as default };
//# sourceMappingURL=styles.module.less.js.map
